import { ComponentProps, useState } from 'react'
import { Base } from '@itsrever/design-system'

const { Input } = Base

// Keeps the text as typed, like the shipping cost input: a number input reads "7." as empty and would reset it.
export const DecimalInput: React.FC<
  Omit<ComponentProps<typeof Input>, 'value' | 'onChange'> & {
    value: number
    parse: (text: string) => number
    // How a value set from outside reads, e.g. euros with two decimals.
    format?: (value: number) => string
    onChange: (value: number) => void
  }
> = ({ value, parse, format = String, onChange, ...props }) => {
  const [typed, setTyped] = useState({ text: format(value), value })
  // A reset or a discard changes the value from outside; the merchant's own edits keep their text.
  if (!Object.is(typed.value, value)) setTyped({ text: format(value), value })
  return (
    <Input
      {...props}
      inputMode="decimal"
      value={typed.text}
      onChange={(event) => {
        const text = event.currentTarget.value
        const next = parse(text)
        setTyped({ text, value: next })
        onChange(next)
      }}
    />
  )
}
